var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pfol row" },
    [
      _c("div", { staticClass: "pfol__header small-12" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("tenantProjects.comments")) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pfol__main small-12" }, [
        _vm.postFitoutComments.length
          ? _c(
              "div",
              { staticClass: "pfol__body" },
              _vm._l(_vm.postFitoutComments, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "pfol__history-item row" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pfol__history-title",
                        on: {
                          click: function () {
                            return _vm.showCommentsDetail(item)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "tenantProjects.postFitout.titleWithNumber",
                                [item.order ? item.order + 1 : ""]
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "tip small-5" }, [
                      _c("div", { staticClass: "tip__text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.getCommentActionText(item)) +
                            "\n          "
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            )
          : _c("div", { staticClass: "hint" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("tenantProjects.postFitout.noLetterHint")) +
                  "\n    "
              ),
            ]),
      ]),
      _vm._v(" "),
      _c(
        "HKLModal",
        {
          ref: "tenantPreviewModalRef",
          attrs: { size: "large", closable: true, dialogStyle: { top: "0" } },
        },
        [
          _c("CommentsPreviewBody", {
            attrs: {
              isBatchesView: false,
              activeBatch: _vm.activeBatch,
              showRecipientsReadOnly: true,
            },
          }),
          _vm._v(" "),
          _c("TenantSubmissionDocuments", {
            attrs: {
              files: _vm.files,
              sourceId: (_vm.currentBatch || {}).id || "",
              canEdit: false,
            },
            on: {
              "update:files": function ($event) {
                _vm.files = $event
              },
            },
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }